
import React from "react";

// import { useNavigate } from "react-router-dom";
import RegisterView from "../../components/Register/RegisterView";
import MainWrapper from "../../Wrapper/MainWrapper";
// import { getCookie } from "../../utils/helper";
export default function Register() {

  // const navigate = useNavigate();
  // useEffect(() => {
  //   if (getCookie("yop-token")) {
  //     navigate("/");
  //   }
  // }, [navigate]);
  return (
    <>
      <MainWrapper>
        <RegisterView />
      </MainWrapper>
    </>
  );
}
